import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICandidate } from '../interface/dto';
import { AuthService } from './http-services/authservice.service';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TableParams } from '../components/grid/TableParams';
import { ExamService } from './exam-service.service';
import { env } from 'process';


@Injectable({
  providedIn: 'root'
})
export class CandidateService {

  constructor(private httpClient: HttpClient, private auth: AuthService,private examService: ExamService) { }
  configureHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', `Bearer ${this.auth.token}`);
    return headers;
  }

  setSelectedCandidate(candidates: ICandidate[]) {
    sessionStorage.setItem("selectedCandidates", JSON.stringify(candidates))
  }

  get selectedCandidates() {
    return JSON.parse(sessionStorage.getItem("selectedCandidates")) as ICandidate[]
  }
  get selectedCandidateIds() {
    if (this.selectedCandidates == null || this.selectedCandidates?.length === 0) {
      return 0;
    }
    return this.selectedCandidates?.map(x => x.candidateId);
  }

  async getCandidates(tableParam: TableParams) {
    return await lastValueFrom(this.httpClient.patch(
      `${environment.apiURL}candidate/`,
      tableParam, { headers: this.configureHeaders() }
    ), { defaultValue: [] });
  }

  async getCandidateSEBLockouts(tableParams: TableParams) {
    return await lastValueFrom(this.httpClient.patch(
      `${environment.apiURL}candidate/seb-lockouts`,
      tableParams, { headers: this.configureHeaders() }
    ), { defaultValue: [] });
  }

  async getCandidate(examNo) {
    return this.httpClient.get(
      `${environment.apiURL}candidate/${examNo}`, { headers: this.configureHeaders() }).toPromise();
  }

  async getCandidatePassport(data) {

    return this.httpClient.get(
      `${environment.apiURL}candidate/passport/${data}`, { headers: this.configureHeaders() }).toPromise();
  }

  async updateCandidate(data) {
    return this.httpClient.put(
      `${environment.apiURL}candidate`, data, { headers: this.configureHeaders() }).toPromise();
  }

  async createCandidate(data) {
    return this.httpClient.post(
      `${environment.apiURL}candidate`, data, { headers: this.configureHeaders() }).toPromise();
  }

  async deleteCandidate(candidateIds) {
    return this.httpClient.delete(
      `${environment.apiURL}candidate?${candidateIds}`, { headers: this.configureHeaders() }).toPromise();
  }

  async uploadCandidatePassport(data) {
    let header = new HttpHeaders({
      'Content-Disposition': 'multipart/form-data',
      "Authorization": `Bearer ${this.auth.token}`
    });
    return this.httpClient.post(
      `${environment.apiURL}candidate/passport`, data, { headers: header }).toPromise();
  }

  async getCandidateSchedule(data) {

    return this.httpClient.get(
      `${environment.apiURL}candidate/schedule/${data}`, { headers: this.configureHeaders() }).toPromise();
  }

  async resetCandidatePassword(data) {
    return this.httpClient.put(
      `${environment.apiURL}candidate/reset`, data, { headers: this.configureHeaders() }).toPromise();
  }

  async getCandidatesExport(tableParam) {
    return await lastValueFrom(this.httpClient.patch(
      `${environment.apiURL}candidate/export`,
      tableParam, { headers: this.configureHeaders() }
    ), { defaultValue: [] });
  }

  async sendCandidateEmail(data) {
    const result = await this.examService.handleBackgroundTaskRequest(this.httpClient.post(`${environment.apiURL}candidate/sendemail`, data, { headers: this.configureHeaders() }));
    return result;
  }
  async sendCandidateSms(data) {
    return this.httpClient.post(
      `${environment.apiURL}candidate/sendsms`, data, { headers: this.configureHeaders() }).toPromise();
  }
  async uploadPassport(data: FormData) {
    let header = new HttpHeaders({
      'Content-Disposition': 'multipart/form-data',
      "Authorization": `Bearer ${this.auth.token}`
    });
    return this.httpClient.post(`${environment.apiURL}candidate/passport/upload`, data, { headers: header }).toPromise();
  }
  async defaultEmailMessage(isDefault: boolean) {
    return this.httpClient.get(`${environment.apiURL}candidate/defaultemailmessage?isDefault=${isDefault}`, { headers: this.configureHeaders() }).toPromise();
  }
  async importPasswordFromExcel(data: FormData) {
    let header = new HttpHeaders({
      'Content-Disposition': 'multipart/form-data',
      "Authorization": `Bearer ${this.auth.token}`
    });
    return this.httpClient.post(`${environment.apiURL}candidate/import-password`, data, { headers: header }).toPromise();
  }

  async getCandidateCount(): Promise<any> {
    return this.httpClient.get(`${environment.apiURL}candidate/candidatecount`, { headers: this.configureHeaders() }).toPromise();
  }
  async saveEmailDraft(data) {
    return this.httpClient.post(
      `${environment.apiURL}candidate/saveemaildraft`, data, { headers: this.configureHeaders() }).toPromise();
  }

  async getCandidateLookup(data: any) {
    return await lastValueFrom(this.httpClient.get(
      `${environment.apiURL}candidate/lookup-candidate?searchText=${data.examNo}`, { headers: this.configureHeaders() }
    ), { defaultValue: [] });
  }


  async uploadCandidate(data: FormData) {
    let header = new HttpHeaders({
      'Content-Disposition': 'multipart/form-data',
      "Authorization": `Bearer ${this.auth.token}`
    });
    const result = await this.examService.handleBackgroundTaskRequest(this.httpClient.post(`${environment.apiURL}candidate/upload-candidate`, data, { headers: header }));
    return result;
  }
}
